import { Injectable, Inject } from '@angular/core';
import { convertToParamMap } from '@angular/router';
import { Subject, BehaviorSubject, Observable, of } from 'rxjs';
import { map, tap, switchMap, skipUntil, skip, filter, shareReplay, distinctUntilChanged } from 'rxjs/operators';
import { PageName, Pager, SortBy, HOLDINGPAGES, Chip, Partner, School, Question, Person, ParamsType } from '@app/constants';


@Injectable({
  providedIn: 'root'
})
export class PagesService {

	private initPage: any = {
		pageName: 'uvod',
		url: ''
	};
	
	private _route$ = new BehaviorSubject<any>(this.initPage);
	public route$ = this._route$.pipe(
		shareReplay({ bufferSize: 1, refCount: true }),
		//tap(_ => console.log('**** PagesService route$ _ ', _))
	);

	private _queryParams$ = new BehaviorSubject<ParamsType>({});
	public queryParams$ = this._queryParams$.pipe(
		//tap(_ => console.log('**** PagesService _queryParam$ _ ', _)),
		
    map((queryParams: ParamsType) => {
    	const newQueryParams = {...queryParams};

      if (this._route$.value.data.virtualParent) {
        
        const map = convertToParamMap(newQueryParams);
        let sections = map.getAll('sekce');
        
        //console.log('**** PagesService newQueryParams$ sections ', sections);
        
        if (sections && !sections.includes(this._route$.value.pageName)) {
          sections.push(this._route$.value.pageName);
          newQueryParams['sekce'] = sections;
        }          
      }
      return newQueryParams;
    }),
    //shareReplay({ bufferSize: 1, refCount: true }),
		//tap(_ => console.log('**** PagesService _queryParam$ _ ', _))

	);

	constructor(){

	}
	
	/* PAGE */

	public setCurrentRoute = (page: any) => {
		//console.log('====> PagesService setCurrentPage page ', page);
		
		this._route$.next(page);
		this._queryParams$.next(page.queryParams);
	}

	public getCurrentPageName = (): string => this._route$.value.pageName;	
	public getCurrentPage = (): any => this._route$.value;
	
	/* SECTIONS */

	public getSectionName = (): string => this._route$.value.section;
}




